import { IDeliverableConfigurator } from "@shared/lib/types";
import { IBriefDeliverable } from "@shared/lib/types/briefInfluencerV2";
import { DeliverablePillSummary } from "@shared/ui/DeliverablePillSummary";

interface BriefDeliverablePillProps {
  deliverable: IBriefDeliverable;
  configurators: IDeliverableConfigurator[];
  showTooltip?: boolean;
  showSpecialNotes?: boolean;
}

export function BriefDeliverablePill({
  deliverable,
  configurators,
  showTooltip,
  showSpecialNotes,
}: BriefDeliverablePillProps) {
  return (
    <DeliverablePillSummary
      deliverable={deliverable}
      compact
      configurators={configurators}
      showTooltip={showTooltip}
      showSpecialNotes={showSpecialNotes}
    />
  );
}
